import script from "./Snow3dShowMode.vue?vue&type=script&setup=true&lang=js"
export * from "./Snow3dShowMode.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__